import { useEffect } from "react";

const CalendarNotifier = ({ userEmail }) => {
  useEffect(() => {
    if (typeof window !== "undefined" && !window.OneSignalInitialized) {
      window.OneSignal = window.OneSignal || [];
      window.OneSignal.push(function () {
        window.OneSignal.init({
          appId: "20b29d87-7fe4-4ca8-9b2b-17e48be459f0",
          notifyButton: { enable: true },
        });

        if (userEmail) {
          window.OneSignal.sendTag("email", userEmail);
          console.log("🔗 OneSignal registrato con utente:", userEmail);
        }
      });

      window.OneSignalInitialized = true;
    }
  }, [userEmail]);

  return null;
};

export default CalendarNotifier;
